import React, { useState } from "react";
import PasswordInput from "./PasswordInput";
import { BASE } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function TrocarSenha() {
  const { userData, login, logout } = useAuth();
  const navigate = useNavigate();
  const obrigatoria = !!userData.troca_senha_obrigatoria;
  const username = userData.username || "";
  // Quem autoriza o uso dos dados é o titular, e este é o momento em que ele está na tela.
  // Quem já autorizou antes não é perguntado de novo (ex.: senha redefinida pelo administrativo).
  const precisaAutorizar = obrigatoria && !userData.lgpd_autorizada;

  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [autoriza, setAutoriza] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMensagem("");
    setErro("");

    if (!username) { setErro("Usuário não identificado. Faça login novamente."); return; }
    if ((!obrigatoria && !senhaAtual) || !novaSenha || !confirmarSenha) { setErro("Preencha todos os campos."); return; }
    if (novaSenha !== confirmarSenha) { setErro("A nova senha e a confirmação não coincidem."); return; }
    if (precisaAutorizar && !autoriza) { setErro("Confirme a autorização de uso dos seus dados para continuar."); return; }

    setLoading(true);
    try {
      const response = await fetch(`${BASE}/auth/switch-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          old_pass: obrigatoria ? undefined : senhaAtual,
          new_pass: novaSenha, confirm_pass: confirmarSenha,
          lgpd_autorizada: precisaAutorizar ? autoriza : undefined,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErro(data.error || data.message || "Erro ao alterar senha.");
        return;
      }

      setMensagem(data.message || "Senha alterada com sucesso.");
      setSenhaAtual("");
      setNovaSenha("");
      setConfirmarSenha("");
      login(data.user, data.token);
      if (obrigatoria) navigate('/', { replace: true });
    } catch {
      setErro("Não foi possível conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ds-auth-wrapper">
      <div className="ds-auth-card">
        <span className="ds-auth-accent" />
        <h2 className="ds-auth-title">{obrigatoria ? 'Defina sua nova senha' : 'Trocar Senha'}</h2>
        <p className="ds-auth-subtitle">{obrigatoria
          ? 'Sua senha de acesso é temporária. Escolha e confirme uma senha pessoal para continuar.'
          : 'Altere sua senha de acesso com segurança.'}</p>
        <p>Use ao menos 8 caracteres, com letras maiúsculas, minúsculas e números.</p>

        <form className="ds-form" onSubmit={handleSubmit}>
          <div className="ds-form-group">
            <label className="ds-label">Usuário</label>
            <input className="ds-input" type="text" value={username} disabled />
          </div>

          {!obrigatoria && <div className="ds-form-group">
            <label className="ds-label" htmlFor="senha-atual">Senha atual</label>
            <PasswordInput id="senha-atual"
              value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)}
              placeholder="Digite sua senha atual" disabled={loading} />
          </div>}

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="nova-senha">Nova senha</label>
            <PasswordInput id="nova-senha"
              value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)}
              placeholder="Digite a nova senha" required autoComplete="new-password" disabled={loading} />
          </div>

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="confirmar-senha">Confirmar nova senha</label>
            <PasswordInput id="confirmar-senha"
              value={confirmarSenha} onChange={(e) => setConfirmarSenha(e.target.value)}
              placeholder="Confirme a nova senha" required autoComplete="new-password" disabled={loading} />
          </div>

          {precisaAutorizar && <div className="ds-alert ds-alert-info">
            <div>
              <strong>Uso dos seus dados</strong>
              <p style={{ margin: '6px 0 0' }}>
                Para usar o sistema, a 61 Imóveis trata seus dados de cadastro e de trabalho
                (contato, equipe, visitas, captações e propostas). Veja o que é guardado, por
                quanto tempo e como pedir acesso ou correção nas{' '}
                <a href="/privacidade" target="_blank" rel="noreferrer">orientações de privacidade</a>.
              </p>
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginTop: 12, fontWeight: 700 }}>
                <input type="checkbox" checked={autoriza} disabled={loading}
                  onChange={(e) => setAutoriza(e.target.checked)} />
                Autorizo o tratamento dos meus dados para essas finalidades
              </label>
            </div>
          </div>}

          {erro     && <div className="ds-alert ds-alert-error">{erro}</div>}
          {mensagem && <div className="ds-alert ds-alert-success">{mensagem}</div>}

          <button type="submit" className="ds-btn ds-btn-primary ds-btn-full" disabled={loading}>
            {loading ? <><span className="ds-spinner" /> Alterando...</> : 'Alterar senha'}
          </button>
        </form>
        {obrigatoria && <button className="ds-btn ds-btn-full" type="button" onClick={logout}>Sair da conta</button>}
      </div>
    </div>
  );
}
